"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaChartDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableAreaChart_1 = require("./PluggableAreaChart");
var BigChartDescriptor_1 = require("../BigChartDescriptor");
var drillDownUtil_1 = require("../drillDownUtil");
var AreaChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(AreaChartDescriptor, _super);
    function AreaChartDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AreaChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableAreaChart_1.PluggableAreaChart(params); };
    };
    AreaChartDescriptor.prototype.applyDrillDown = function (insight, drillDownContext) {
        var withFilters = this.addFilters(insight, drillDownContext.drillDefinition, drillDownContext.event);
        return drillDownUtil_1.modifyBucketsAttributesForDrillDown(withFilters, drillDownContext.drillDefinition);
    };
    AreaChartDescriptor.prototype.addFilters = function (source, drillConfig, event) {
        var cutIntersection = drillDownUtil_1.reverseAndTrimIntersection(drillConfig, event.drillContext.intersection);
        return drillDownUtil_1.addIntersectionFiltersToInsight(source, cutIntersection);
    };
    return AreaChartDescriptor;
}(BigChartDescriptor_1.BigChartDescriptor));
exports.AreaChartDescriptor = AreaChartDescriptor;
//# sourceMappingURL=AreaChartDescriptor.js.map